export function sanitizeHTML(htmlString: string): string {
  if (!htmlString) {
    return ''
  }

  // Remove tags HTML proibidas dentro de textos (ex: <html>, <head>, <style>, <script>)
  let cleaned = htmlString.replace(/<\/?(html|head|style|script)[^>]*>/gi, '')

  // Remove atributos perigosos (onload, onclick, etc.)
  cleaned = cleaned.replace(/\son\w+="[^"]*"/gi, '')

  // NOTE: DOMParser was removed here because it is a browser-only API.
  // During SSR/SSG, DOMParser is undefined, so the server would return
  // regex-only cleaned HTML while the client would return DOMParser-normalized
  // HTML — causing React hydration mismatch (error #418) on every product page.

  return cleaned
}
